if (!customElements.get('two-color-metal')) {
	class TwoColorMetal extends HTMLElement {
		constructor() {
			super();
			this.metalEls = Array.from(document.querySelectorAll('.custom-option input[name="Metal"]'));
			this.outsideToneEls = Array.from(this.querySelectorAll('.custom-option__outside'));
			this.insideToneEls = Array.from(this.querySelectorAll('.custom-option__inside'));
			this.outsideSubtitle = this.querySelector('.custom-options__outside-subtitle');
			this.insideSubtitle = this.querySelector('.custom-options__inside-subtitle');

			this.abbrValues = {
				X: 'yellow/white',
				U: 'white/yellow',
				Z: 'rose/white',
				V: 'white/rose',
				Y: 'yellow/yellow',
				W: 'white/white',
				R: 'rose/rose',
			};

			const activeMetalElement = document.querySelector(
				'.custom-option.active input[name="Metal"]',
			);
			this.activeMetalAbbr = activeMetalElement?.dataset.metalAbbreviation;
			this.activeTones = this.abbrValues[this.activeMetalAbbr]?.split('/');

			this.currentProductMetalAbbrs = this.metalEls.map((el) => el.dataset.metalAbbreviation);
			// eslint-disable-next-line no-undef
			this.filteredCurrentProductMetalAbbrs = [...new Set(this.currentProductMetalAbbrs)];
			this.currentMetalNames = this.filteredCurrentProductMetalAbbrs.map(
				(el) => this.abbrValues[el],
			);
			this.activeOutsideColorValue = null;

			this.init();
		}

		updateMetalOption() {
			this.metalEls.forEach((el) => {
				const isSimilarMetalAbbr = el.dataset.metalAbbreviation !== this.activeMetalAbbr;
				el.closest('.custom-option').classList.toggle('hidden-metal', isSimilarMetalAbbr);
			});
		}

		updateTwoToneOptions() {
			this.filteredCurrentProductMetalAbbrs.forEach((abbr) => {
				const [outsideTone, insideTone] = this.abbrValues[abbr].split('/');

				this.setToneVisibility(this.outsideToneEls, outsideTone);
				this.setToneVisibility(this.insideToneEls, insideTone);
			});
		}

		setToneVisibility(toneEls, tone) {
			toneEls.forEach((el) => {
				const { metalColor } = el.dataset;
				metalColor === tone && el.classList.add('visible');
			});
		}

		handleOutsideToneElClick(evt) {
			const { metalColor } = evt.currentTarget.dataset;
			this.activeOutsideColorValue = metalColor;
			this.outsideSubtitle.textContent = `${metalColor} Gold`;
			this.toggleActiveClass(this.outsideToneEls, evt.currentTarget);

			this.changeMetalOptions(metalColor, this.insideToneEls, 'outside');
			this.updateInsideTones();
		}

		handleInsideToneElClick(evt) {
			const { metalColor } = evt.currentTarget.dataset;
			this.insideSubtitle.textContent = `${metalColor} Gold`;
			this.toggleActiveClass(this.insideToneEls, evt.currentTarget);

			this.changeMetalOptions(metalColor, this.outsideToneEls, 'inside');
		}

		toggleActiveClass(toneEls, activeElement) {
			toneEls.forEach((el) => el.classList.remove('active'));
			activeElement.classList.add('active');
		}

		setInititalOutsideTones() {
			this.outsideToneEls.forEach((el) => {
				const { metalColor } = el.dataset;

				if (metalColor === this.activeTones[0]) {
					el.classList.add('active');
					this.outsideSubtitle.textContent = `${metalColor} Gold`;
					this.activeOutsideColorValue = metalColor;
				} else {
					el.classList.remove('active');
				}
			});
		}

		setInititalInsideTones() {
			this.insideToneEls.forEach((el) => {
				const { metalColor } = el.dataset;

				if (metalColor === this.activeTones[1]) {
					el.classList.add('active');
					this.insideSubtitle.textContent = `${metalColor} Gold`;
				} else {
					el.classList.remove('active');
				}
			});
		}

		updateOutsideTones() {
			this.outsideToneEls.forEach((el) => {
				const { metalColor } = el.dataset;
				if (metalColor === this.activeTones[0]) {
					el.classList.add('active');
					this.outsideSubtitle.textContent = `${metalColor} Gold`;
				} else {
					el.classList.remove('active');
				}
			});
		}

		updateInsideTones() {
			this.insideToneEls.forEach((el) => {
				const { metalColor } = el.dataset;
				if (metalColor === this.activeTones[1]) {
					el.classList.add('active');
					this.insideSubtitle.textContent = `${metalColor} Gold`;
				} else {
					el.classList.remove('active');
				}

				const colorCombination = `${this.activeOutsideColorValue}/${metalColor}`;
				const isColorCombinationExist = this.currentMetalNames.includes(colorCombination);
				el.classList.toggle('disabled', !isColorCombinationExist);
			});
			this.handleNonExistentCombination();
		}

		handleNonExistentCombination() {
			const nonExistedCombinationEl = this.querySelector(
				'.custom-option__inside.visible.disabled.active',
			);
			if (nonExistedCombinationEl) {
				nonExistedCombinationEl.classList.remove('active');
				const firstActiveInsideEl = this.insideToneEls.find(
					(el) => !el.classList.contains('disabled'),
				);
				firstActiveInsideEl?.click();
			}
		}

		changeMetalOptions(color, toneEls, side) {
			const activeTone =
				toneEls.find((el) => el.classList.contains('active'))?.dataset.metalColor || '';
			const selectedColors =
				side === 'outside' ? `${color}/${activeTone}` : `${activeTone}/${color}`;

			if (!this.currentMetalNames.includes(selectedColors)) {
				this.updateInsideTones();
				return;
			}

			const [currentMetalAbbr] =
				// eslint-disable-next-line no-unused-vars
				Object.entries(this.abbrValues).find(([abbr, tones]) => tones === selectedColors) || [];
			const prevActiveMetal = this.metalEls.find((el) => el.checked);
			const prevActiveMetalValue = prevActiveMetal.value.split(' ')[0];

			this.metalEls.forEach((el) => {
				if (el.dataset.metalAbbreviation !== currentMetalAbbr) {
					el.closest('.custom-option').classList.add('hidden-metal');
					el.closest('.custom-option').classList.remove('active');
					if ('checked' in el) {
						el.checked = false;
					}
				} else {
					el.closest('.custom-option').classList.remove('hidden-metal');
				}
			});

			const allVisibleMetalOpt = this.metalEls.filter(
				(el) => !el.closest('.custom-option').classList.contains('hidden-metal'),
			);

			const activeMetalOpt =
				allVisibleMetalOpt.find((el) => el.value.split(' ')[0] === prevActiveMetalValue) ||
				allVisibleMetalOpt[0];

			if (activeMetalOpt) {
				const optionElement = activeMetalOpt.closest('.custom-option');
				optionElement.classList.add('active');
				activeMetalOpt.click();

				this.activeMetalAbbr = activeMetalOpt.dataset.metalAbbreviation;
				this.activeTones = this.abbrValues[this.activeMetalAbbr]?.split('/');
			}
		}

		setupEventListeners() {
			this.outsideToneEls.forEach((el) =>
				el.addEventListener('click', this.handleOutsideToneElClick.bind(this)),
			);
			this.insideToneEls.forEach((el) =>
				el.addEventListener('click', this.handleInsideToneElClick.bind(this)),
			);
		}

		init() {
			this.updateMetalOption();
			this.setInititalOutsideTones();
			this.setInititalInsideTones();
			this.updateTwoToneOptions();
			this.setupEventListeners();
			this.updateInsideTones();
			this.updateOutsideTones();
		}
	}
	customElements.define('two-color-metal', TwoColorMetal);
}
